// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__ziRly","content":"styles_content__33GIx","leftContent":"styles_leftContent__1meyb","button":"styles_button__3zYon"};